module.exports = __webpack_public_path__ + "static/media/show.61e88c5b.svg";